export const Default = 'block w-full richTextComponent [&>ul]:ml-8 [&>ol]:ml-8'
